import { AccountContext } from 'components/Account/Account';
import { useContext, useEffect, useMemo, useState,useRef } from "react";
import Select from 'react-select'
import { Container, Row, Col, Modal, Spinner, Form, InputGroup, FormControl, Button, Card } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import empresas from 'api/empresas';
import getDevicesByTenant from 'api/getDevicesByTenant';
import { Input } from 'reactstrap';
import getRangoFolios from 'api/getRangoFolios';
import downloadCSV from '../csv/downloadCSV'


const columns = [
  {
    name: "Rut",
    selector: (row) => row.rut,
    sortable: true,
    width: "10%",
  },
  {
    name: "Device ID",
    selector: (row) => row.device_id,
    sortable: true,
    width: "35%",
  },

  {
    name: "Tipo de Documento",
    selector: (row) => row.document_type,
    sortable: true,
    width: "15%",
  },
  {
    name: "Folio Inicial",
    selector: (row) => row.folio_ini,
    sortable: true,
    width: "14%",
  },
  {
    name: "Folio Final",
    selector: (row) => row.folio_fin,
    sortable: true,
    width: "14%",
  },
  {
    name: "Fecha petición",
    selector: (row) => new Date(row.fecha_peticion).toISOString().slice(0, 10),
    sortable: true,
    width: "12%",
  },
];


function RangoFolios () {

  
  const [modalDescarga, setModalDescarga] = useState(false);
  const [loading, setloading] = useState(true);
  const [modalMensaje, setmodalMensaje] = useState("");
  const [errorSearch, setErrorSearch] = useState(false);
  const {getSession } = useContext(AccountContext);
  const [user, setUser] = useState(null);

  const [startDate, setStartDate] = useState(new Date().toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [tipoDocumento, settipoDocumento] = useState(39);
  //company
  const [empresaList, setEmpresaList] = useState([]);
  const [empresa, setEmpresa] = useState("");
  const [empresaOptions, setEmpresaOptions] = useState([]);
  const [companyLoading, setCompanyLoading] = useState(true);
  //devices
  const [device, setDevice] = useState('');
  const [deviceOptions, setdeviceOptions] = useState([]);
  const [deviceLoading, setDeviceLoadingLoading] = useState(false);
  const [defaultDevice, setdefaultDevice] = useState({ value: 'Todos', label: "Todos" })

  const [folioIni, setfolioIni] = useState('');
  const [folioFin, setfolioFin] = useState('');

  const [responseData, setResponseData] = useState(null);
  const [dataToExport, setdataToExport] = useState(null);

 

  const closeModal = () => {
    setModalDescarga(false);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }


  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    // console.log('token: ',user.idToken.jwtToken);

    getSession().then((session) => {
      // console.log('session:',session.idToken.jwtToken);
      setUser(session);
      empresas
        .getEmpresas(session.idToken.jwtToken)
        .then((response) => {
          setEmpresaList(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    });

    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const arrayOptions = [];
    empresaList.forEach((element) => {
      arrayOptions.push({
        value: element.tenant_id,
        label: element.rut + " - " + element.name,
      });
    });
    setCompanyLoading(false);
    setEmpresaOptions(arrayOptions);
  }, [empresaList]);

  useEffect(async () => {
    //Setear opciones de dispositivos por cliente

    if (empresa != "" && user != null) {
      setDeviceLoadingLoading(true);
      setdeviceOptions([]);
      // console.log(empresa);
      const response = await getDevicesByTenant(user.idToken.jwtToken, empresa);
      // console.log(response.data.records);
      const arrayOptions = [{ value: '', label: 'Todos' }];
      response.data.forEach((element) => {
        arrayOptions.push({
          value: element.device_id,
          label: element.device_id,
        });
      });
      setDeviceLoadingLoading(false);
      setdeviceOptions(arrayOptions);
    }
  }, [empresa]);

  function isNumber(str) {
    if (str.trim() === '') {
      return false;
    }
  
    return !isNaN(str);
  }
  

  const Export = ({ onExport }) => <Button onClick={e => onExport(e.target.value)}>Exportar</Button>;
  const actionsMemo = useMemo(() => <Export onExport={() => downloadCSV(responseData)} />, [responseData]);

  const handleSearch = async () => {
   
    try {
      console.log(empresa,startDate,endDate,tipoDocumento,'device:',device,'folio_ini:',folioIni,'folio_fin:',folioFin);

      const arrayToExport=[];
      setModalDescarga(true);
      setloading(true);

      if(empresa==""){
        setmodalMensaje("Debe seleccionar una empresa");
        setloading(false);
        return;
      }
      // if(folioIni=="" || folioFin==""){
      //   setmodalMensaje("Debe ingresar un rango de folios");
      //   setloading(false);
      //   return;
      // }

      if( parseInt(folioIni) > parseInt(folioFin)){
        setmodalMensaje("El folio inicial debe ser menor al folio final");
        setloading(false);
        return;
      }

      // return;
      const params= {tenant_id:empresa,tipodocumento:tipoDocumento,startDate,endDate,device_id:device,folio_ini:folioIni,folio_fin:folioFin}
      const response = await getRangoFolios(params, user.idToken.jwtToken );
      console.log(response.data);
      setloading(false);
      setModalDescarga(false);
      
      setResponseData(response.data);
      response.data.forEach(element => {
        delete element['tenant_id'];
        arrayToExport.push(element);
      });
      setdataToExport(arrayToExport);
    
    } catch (error) {
      setmodalMensaje("Error al buscar folios");
      setloading(false);
      console.log(error);
    }
  };



  const tipoDocumentoOptions = [
    { value: 39, label: "Boleta Electrónica" },
    { value: 41, label: "Boleta Exenta Electrónica" },
  ];

  const paginationOpciones = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsText: "Todos",
  };
  

  return (
    <>
   
      <Container fluid>
        <Card>
          <Row>
            <Col sm={12} md={6} lg={6}>
              <Form.Label>Empresa</Form.Label>
              <Select
                options={empresaOptions}
                defaultValue={empresaOptions[0]}
                onChange={(e) => {
                  setEmpresa(e.value);
                }}
                placeholder="Empresa"
                isLoading={companyLoading}
              />
            </Col>
            <Col sm={12} md={6} lg={3}>
              <Form.Label>Tipo&nbsp;Documento</Form.Label>

              <Select
                options={tipoDocumentoOptions}
                defaultValue={tipoDocumentoOptions[0]}
                onChange={(e) => {
                  settipoDocumento(e.value);
                }}
                // value={tipoDocumento}
              />
            </Col>
            <Col sm={12} md={6} lg={3}>
              <Form.Label>Cajero</Form.Label>
              <Select
                options={deviceOptions}
                defaultValue={defaultDevice}
                onChange={(e) => {
                  setDevice(e.value);
                }}
                isLoading={deviceLoading}
              />
            </Col>

            <Col sm={12} md={6} lg={3}>
              <Form.Label>Folio Inicial</Form.Label>
              <Input
              value={folioIni}
              onChange={(e) => {
                if (isNumber(e.target.value) || e.target.value=='') {
                  setfolioIni(e.target.value)
                }
                }}
              />
            </Col>
            <Col sm={12} md={6} lg={3}>
              <Form.Label>Folio Fin</Form.Label>
              <Input
              value={folioFin}
              onChange={(e) => {
                if (isNumber(e.target.value) || e.target.value=='') {
                  setfolioFin(e.target.value)
                }
                }}
              />
            </Col>

            <Col sm={12} md={6} lg={3}>
              <Form.Label>Desde</Form.Label>
              <FormControl
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Col>
            <Col sm={12} md={6} lg={3}>
              <Form.Label>Hasta</Form.Label>
              <FormControl
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col className="mt-3 text-nowrap">
              <Button variant="primary" onClick={handleSearch}>Buscar</Button>
            </Col>

            <Col></Col>
            {/* <Col className="mt-3 text-right text-nowrap">
                    <Button variant="secondary" onClick={() => {setStartDate("");setEndDate("");setDocType("");setFolio("")} }>Limpiar<FaEraser className="ml-3"/></Button>&nbsp;
                </Col> */}
          </Row>
        </Card>

        {responseData && 
        <Card>
          <Card.Header>Resultados</Card.Header>
          <Card.Body>
            <DataTable
              className="-striped -highlight"
              // fixedHeader={true}
              noDataComponent="No hay folios asignados en el rango seleccionado" 
              columns={columns}
              data={responseData}
              pagination
              paginationComponentOptions={paginationOpciones}
              actions={actionsMemo}
            />
          </Card.Body>
        </Card>}
      </Container>

      <Modal show={modalDescarga}>
        <Modal.Header>
          {loading && <Modal.Title>Búsqueda rangos de folios</Modal.Title>}
          {!loading && <Modal.Title>{modalMensaje}</Modal.Title>}
        </Modal.Header>
        <Modal.Body>
          {/* {!errorSearch && !loading} */}
          {loading && (
            <Spinner
              animation="border"
              role="status"
              className="sticky-top"
            ></Spinner>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!loading && (
            <>
              <Button variant="secondary" onClick={closeModal}>
                Close
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default RangoFolios;